import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Lock, Phone } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const { isAuthenticated, sendOtp, verifyOtp } = useAuth();
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState<'mobile' | 'otp'>('mobile');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSendOtp = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await sendOtp(mobile);
      setStep('otp');
    } catch (err: any) {
      setError(err.message || 'Unable to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await verifyOtp(mobile, otp);
    } catch (err: any) {
      setError(err.message || 'Unable to verify OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-panel">
        <div className="login-brand">
          <div className="brand-mark large">M</div>
          <div>
            <h1>Minto Technician</h1>
            <p>Sign in with your registered mobile number.</p>
          </div>
        </div>

        <form onSubmit={step === 'mobile' ? handleSendOtp : handleVerifyOtp} className="login-form">
          <label>
            Mobile Number
            <div className="input-wrap">
              <Phone size={18} />
              <input
                value={mobile}
                onChange={(event) => setMobile(event.target.value.replace(/\D/g, '').slice(0, 10))}
                placeholder="10 digit mobile"
                disabled={step === 'otp' || loading}
              />
            </div>
          </label>

          {step === 'otp' && (
            <label>
              OTP
              <div className="input-wrap">
                <Lock size={18} />
                <input
                  value={otp}
                  onChange={(event) => setOtp(event.target.value.replace(/\D/g, '').slice(0, 6))}
                  placeholder="Enter OTP"
                  disabled={loading}
                />
              </div>
            </label>
          )}

          {error && <div className="form-error">{error}</div>}

          <button className="primary-button" disabled={loading || mobile.length !== 10 || (step === 'otp' && otp.length < 4)}>
            {loading ? 'Please wait...' : step === 'mobile' ? 'Send WhatsApp OTP' : 'Verify & Login'}
          </button>

          {step === 'otp' && (
            <button type="button" className="text-button" onClick={() => setStep('mobile')} disabled={loading}>
              Change mobile number
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
